
/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "TaskAddEditModal",
  components: { customModal },

  props: {
    taskData: {
      type: Object,
      default: null
    },
    visitType: {
      type: Object,
      required: true
    }

  },

  emits: ["closeModal", "save"],

  data() {
    return {
      task: {
        title: "",
        questions: []
      },
      baseurl: process.env.VUE_APP_Service_URL,
      editingQuestionId: null,
      errors: {
        title: ""
      }
    };
  },

  computed: {
    isEditMode() {
      return !!this.taskData;
    }
  },

  mounted() {
    if (this.taskData) {
      this.task = {
        title: this.taskData.name,
        questions: (this.taskData.questions || []).map(q => ({
          id: Date.now() + Math.random(),
          questionId: q.questionId,
          text: q.text,
          isNew: false
        }))
      };
    }
  },


  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    addQuestion() {
      const newQuestion = {
        id: Date.now() + Math.random(),
        text: "",
        isNew: true
      };

      this.task.questions.push(newQuestion);
      this.editingQuestionId = newQuestion.id;
    },



    async removeQuestion(index) {
      if (!confirm("Are you sure you want to delete this question?")) return;

      const question = this.task.questions[index];

      if (!question || !question.questionId) {
        alert("Invalid question selected");
        return;
      }
      this.task.questions.splice(index, 1);

      if (!this.isEditMode) return;

      const token = store.getters.getIdToken;

      const payload = {
        studyId: store.getters.getStudyIs,
        visitTypeId: this.visitType.id,
        checklistId: this.taskData.id,
        deleteAllQuestions: false,
        questionId: question.questionId
      };

      try {
        await axios.delete(
          `${this.baseurl}/forms/cra/deletecrachecklisttemp`,
          {
            data: payload,
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        alert("Question deleted successfully");

      } catch (err) {
        console.error(err);
        alert("Failed to delete question");

        await this.reloadQuestions();
      }
    },



    async saveTask() {
      this.errors.title = "";

      if (!this.task.title.trim()) {
        this.errors.title = "Checklist title is required";
        return;
      }

      const validQuestions = this.task.questions
        .filter(q => q.text && q.text.trim() !== "")
        .map(q => ({
          questionId: q.questionId || null,
          text: q.text.trim()
        }));

      // if (!validQuestions.length) {
      //   alert("At least one question is required");
      //   return;
      // }

      const token = store.getters.getIdToken;
      const isEdit = this.isEditMode;

      const checklistItem = {
        title: this.task.title.trim(),
        questions: validQuestions
      };

      const payload = isEdit
        ? {
          studyId: store.getters.getStudyIs,
          visitType: this.visitType.type,
          craChecklistTempId: this.taskData.craChecklistTempId,
          checklist: [
            {
              checklistId: this.taskData.id,
              ...checklistItem
            }
          ]
        }
        : {
          studyId: store.getters.getStudyIs,
          visitType: this.visitType.type,
          visitTypeId: this.visitType.id,
          checklist: [checklistItem]
        };

      const apiUrl = isEdit
        ? `${this.baseurl}/forms/cra/updatecrachecklisttemp`
        : `${this.baseurl}/forms/cra/createcrachecklisttemp`;

      try {
        await axios({
          method: isEdit ? "put" : "post",
          url: apiUrl,
          data: payload,
          headers: { Authorization: `Bearer ${token}` }
        });

        alert(isEdit ? "Checklist updated successfully" : "Checklist created successfully");
        this.$emit("saved");
        this.closeModal();
      } catch (err) {
        console.error(err);
        alert("Failed to save checklist");
      }
    },



    editQuestion(question) {
      this.editingQuestionId = question.id;
      console.log("Editing question:", question);
    },
    cancelEditQuestion() {
      this.editingQuestionId = null;
    },
    async saveQuestion(question) {
      if (!question.text.trim()) {
        this.task.questions = this.task.questions.filter(
          q => q.text.trim() !== "" || !q.isNew
        );
        this.editingQuestionId = null;
        return;
      }

      if (!this.isEditMode) {
        question.isNew = false;
        this.editingQuestionId = null;
        return;
      }

      const token = store.getters.getIdToken;

      const payload = {
        studyId: store.getters.getStudyIs,
        visitType: this.visitType.type,
        craChecklistTempId: this.taskData.craChecklistTempId,
        checklistId: this.taskData.id,
        checklist: {
          title: this.task.title,
          questions: this.task.questions
            .filter(q => q.text && q.text.trim() !== "")
            .map(q => ({
              questionId: q.questionId || null,
              text: q.text.trim()
            }))
        }
      };

      try {
        await axios.put(
          `${this.baseurl}/forms/cra/updatecratempquestion`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        question.isNew = false;
        this.editingQuestionId = null;
        alert("Question saved successfully");
        await this.reloadQuestions();

      } catch (err) {
        console.error(err);
        alert("Failed to save question");
      }
    },

    async reloadQuestions() {
      const token = store.getters.getIdToken;

      const res = await axios.get(
        `${this.baseurl}/forms/cra/getchecklistbyvisit`,
        {
          params: {
            visitId: this.visitType.id,
            studyId: store.getters.getStudyIs
          },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const checklist = res.data?.checklist?.find(
        c => c.checklistId === this.taskData.id
      );

      if (checklist) {
        this.task.questions = checklist.questions.map(q => ({
          id: Date.now() + Math.random(),
          questionId: q.questionId,
          text: q.text,
          isNew: false
        }));

      }
    },
    async deleteAllQuestions() {
      if (!confirm("Are you sure you want to delete all questions?")) return;

      if (!this.isEditMode) return;

      const token = store.getters.getIdToken;

      const payload = {
        studyId: store.getters.getStudyIs,
        visitTypeId: this.visitType.id,
        checklistId: this.taskData.id,
        deleteAllQuestions: true,
        questionId: null
      };

      try {
        await axios.delete(
          `${this.baseurl}/forms/cra/deletecrachecklisttemp`,
          {
            data: payload,
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        this.task.questions = [];
        this.editingQuestionId = null;

        alert("All questions deleted successfully");

      } catch (err) {
        console.error(err);
        alert("Failed to delete all questions");
        await this.reloadQuestions();
      }
    }







  }
};
